<div class="container" fxLayout="column">
  <div class="panel" fxLayout="column">
    <!--        <div class="panel-header">-->
    <!--            Custom Contact-->
    <!--        </div>-->
    <!--        <div class="panel-description">-->
    <!--            The Agency You Appoint That Will Be Shown On The Project Page-->
    <!--        </div>-->
    <!--        <div class="button-group" fxLayout="row">-->
    <!--            <div class="button" fxFlex="50" fxLayout="row" fxLayoutGap="10px" (click)="handleTabIndexChange($event)"-->
    <!--                fxLayoutAlign="center center"-->
    <!--                style="border-top-left-radius: 8px; border-bottom-left-radius: 8px;cursor: pointer;border: 0;"-->
    <!--                [ngStyle]="{background: tabIndex===0 ? '#0E0D0D':'#2142FF'}">-->
    <!--                <mat-icon *ngIf="this.savedType  === 1 || this.savedType  === 3"-->
    <!--                    [ngStyle]="{'color': tabIndex === 1 ? '#dedede':'#dedede'}">done</mat-icon>-->
    <!--                <div [ngStyle]="{color: tabIndex===0 ? '#dedede':'#dedede'}" style="font-size: 14px">Random Display-->
    <!--                </div>-->
    <!--            </div>-->
    <!--            <div class="button" fxFlex="50" fxLayout="row" fxLayoutGap="10px" (click)="handleTabIndexChange($event)"-->
    <!--                fxLayoutAlign="center center"-->
    <!--                style="border-top-right-radius: 8px; border-bottom-right-radius: 8px;cursor: pointer;border: 0;"-->
    <!--                [ngStyle]="{background: tabIndex===1 ? '#0E0D0D':'#2142FF'}">-->
    <!--                <mat-icon *ngIf="this.savedType  === 2" [ngStyle]="{'color': tabIndex === 0 ? '#dedede':'#dedede'}">done-->
    <!--                </mat-icon>-->
    <!--                <div [ngStyle]="{color: tabIndex===1 ? '#dedede':'#dedede'}" style="font-size: 14px">Appoint Agent</div>-->
    <!--            </div>-->
    <!--        </div>-->
    <div class="panel-content">
      <!--            <div *ngIf="tabIndex === 1" style="font-size: 14px;">-->
      <!--                          <mat-radio-group [(ngModel)]="sellersRandomType" fxLayout="column">-->
      <!--                              <mat-radio-button [checked]="this.projectDetail?.sellersRandomType === 1" [value]="1"-->
      <!--                                  color="primary" style="font-weight: bold;margin-bottom: 5px" fxLayout="column">-->
      <!--                                  Random between all agents-->
      <!--                              </mat-radio-button>-->
      <!--                              <div style="color: rgba(0, 0, 0, 0.41);margin-left: 28px;margin-bottom: 15px">Any Agent registered-->
      <!--                                  can appear on the project details page</div>-->
      <!--                              <mat-radio-button [checked]="this.projectDetail?.sellersRandomType === 3" [value]="3"-->
      <!--                                  color="primary" style="font-weight: bold;margin-bottom: 5px" fxLayout="column">-->
      <!--                                  Random between agents who have authority-->
      <!--                              </mat-radio-button>-->
      <!--                              <div style="color: rgba(0, 0, 0, 0.41);margin-left: 28px;margin-bottom: 15px">The Agent who has-->
      <!--                                  authority over this project and adds the project to the store-->
      <!--                                  can random appear on the project details page.</div>-->
      <!--                          </mat-radio-group>-->
      <!--                      </div>-->
      <form class="form" *ngIf="tabIndex === 0" style="font-size: 14px" fxLayout="column">
        <div fxLayout="column" style="margin-bottom: 15px">
          <h3>All Agents ({{totalElements}})</h3>
          <div fxLayout="row" fxLayoutAlign="space-between center" style="margin-bottom:16px">
            <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap=30px>
              <form (submit)="handleSubmit($event)">
                <mat-form-field appearance="outline" style="width: 300px;">
                  <mat-icon style="color: #dedede;margin-right: 15px">search</mat-icon>
                  <input class="search" matInput type="text" style="font-size: 14px"
                         placeholder="Search by Agent Name or by Agency Name" [value]="searchInput"
                         (change)="searchInput = $event.target.value">
                </mat-form-field>
              </form>
            </div>
            <div fxLayout="row" fxLayoutGap="20px" fxLayoutAlign="start center">
              <div>{{agentSelected}} Agent Selected</div>
              <mat-checkbox #showSelected color="primary">Show selected agent</mat-checkbox>
            </div>
          </div>
        </div>

        <div fxLayout="row" fxLayoutAlign="space-between center"
             style="padding: 10px 40px;  border-top-right-radius: 5px; border-top-left-radius: 5px;border: 1px solid rgba(27, 19, 75, 0.15);"
             class="agent-info" fxLayoutGap="20px">
          <div fxLayout="row" fxLayoutGap="20px" fxLayoutAlign="start center" fxFlex="40">
            <mat-checkbox color="primary" (change)="handleCheckAll($event)"
                          style="display: none"></mat-checkbox>
            <!--            <span style="color: #C4C4C4">|</span>-->
            <div class="agent-info__agent">Agent</div>
          </div>
          <span style="color: #C4C4C4">|</span>
          <div fxFlex="25">Agency</div>
          <span style="color: #C4C4C4">|</span>
          <div fxFlex="25">Email</div>
          <span style="color: #C4C4C4">|</span>
          <div fxFlex="10">Mobile</div>
        </div>
        <div fxLayout="column" class="table" style="max-height: 350px;overflow: auto;">
          <div *ngIf="showSelected.checked">
            <div *ngFor="let eachAgency of selectedSales" fxLayout="row"
                 fxLayoutAlign="space-between center" style="padding: 10px 40px;" class="agent-info"
                 fxLayoutGap="20px" [style.padding-left]="matCheckbox?.checked ? '37px' : '40px'"
                 [style.border-left]="matCheckbox?.checked ? '3px solid #293157': 'none'"
                 [style.background]="matCheckbox?.checked ? '#F9F9F9' : 'none'">
              <div fxLayout="row" fxLayoutGap="20px" fxLayoutAlign="start center" fxFlex=40>
                <mat-checkbox #matCheckbox

                              [checked]="isCheckboxChecked(eachAgency)"
                              (change)="handleChecked($event, eachAgency)" color="primary"></mat-checkbox>
                <span style="color: transparent">|</span>
                <img *ngIf="eachAgency.headerUrl" src="{{SERVER_URL}}images/{{eachAgency.headerUrl}}"
                     onerror="this.onerror=null;this.src='./assets/images/default-user.svg';"
                     style="width: 30px; height: 30px;border-radius: 50%;">
                <img *ngIf="!eachAgency.headerUrl" src="./assets/images/default-user.svg"
                     style="width: 30px; height: 30px">
                <div
                  [style.color]="matCheckbox?.checked ? 'orange' : 'white'">
                  {{eachAgency.firstName}} {{eachAgency.lastName}}</div>
              </div>
              <span style="color: transparent">|</span>
              <div fxFlex="25"
                   [style.color]="matCheckbox?.checked ? 'orange' : 'white'">
                {{eachAgency.company?.name}}</div>
              <span style="color: transparent">|</span>
              <div fxFlex="25"
                   [style.color]="matCheckbox?.checked ? 'orange' : 'white'">
                {{eachAgency.contacts[0]?.content}}</div>
              <span style="color: transparent">|</span>
              <div fxFlex="10"
                   [style.color]="matCheckbox?.checked ? 'orange' : 'white'">
                {{eachAgency.contacts[1]?.content &&
              eachAgency.contacts[1]?.content.startsWith('04') ? eachAgency.contacts[1]?.content : ''}}
              </div>
            </div>
          </div>
          <div *ngIf="!showSelected.checked">
            <div *ngFor="let eachAgency of allSalesArray" fxLayout="row"
                 fxLayoutAlign="space-between center" style="padding: 10px 40px;" class="agent-info"
                 fxLayoutGap="20px" [style.padding-left]="matCheckbox?.checked ? '37px' : '40px'"
                 [style.border-left]="matCheckbox?.checked ? '3px solid #293157': 'none'"
                 [style.background]="matCheckbox?.checked ? '#F9F9F9' : 'none'">
              <div fxLayout="row" fxLayoutGap="20px" fxLayoutAlign="start center" fxFlex=40>
                <mat-checkbox #matCheckbox [checked]="isCheckboxChecked(eachAgency)"
                              (change)="handleChecked($event, eachAgency)" color="primary"></mat-checkbox>
                <span style="color: transparent">|</span>
                <img *ngIf="eachAgency.headerUrl" src="{{SERVER_URL}}images/{{eachAgency.headerUrl}}"
                     onerror="this.onerror=null;this.src='./assets/images/default-user.svg';"
                     style="width: 30px; height: 30px;border-radius: 50%;">
                <img *ngIf="!eachAgency.headerUrl" src="./assets/images/default-user.svg"
                     style="width: 30px; height: 30px">
                <div
                  [style.color]="matCheckbox?.checked ? 'orange' : 'white'">
                  {{eachAgency.firstName}} {{eachAgency.lastName}}</div>
              </div>
              <span style="color: transparent">|</span>
              <div fxFlex="25"
                   [style.color]="matCheckbox?.checked ? 'orange' : 'white'">
                {{eachAgency.company?.name}}
              </div>
              <span style="color: transparent">|</span>
              <div fxFlex="25"
                   [style.color]="matCheckbox?.checked ? 'orange' : 'white'">
                {{eachAgency.contacts[0]?.content}}</div>
              <span style="color: transparent">|</span>
              <div fxFlex="10"
                   [style.color]="matCheckbox?.checked ? 'orange' : 'white'">
                {{eachAgency.contacts[1]?.content &&
              eachAgency.contacts[1]?.content.startsWith('04') ? eachAgency.contacts[1]?.content : ''}}
              </div>
            </div>
          </div>
        </div>
        <div
          style="padding: 0 40px;  border-bottom-right-radius: 5px; border-bottom-left-radius: 5px;border: 1px solid rgba(27, 19, 75, 0.15);">
          <mat-paginator [length]="length" [pageIndex]="pageIndex" [pageSize]="pageSize"
                         [pageSizeOptions]="pageSizeOptions" (page)="getSalesByPage(pageSize, $event)">
          </mat-paginator>
        </div>
      </form>
    </div>
    <button mat-button fxFlexAlign="start" (click)="handleSave()"
            style="font-size: 14px;font-weight: 700;background: #2142FF; width: 120px; color: white; margin-top: 40px; border-radius: 4px;"
            ngStyle.lt-sm="width: 100%">
      Save
    </button>
  </div>

</div>
<!-- <div class="container" fxLayout="column">
    <div class="panel" fxLayout="column">
        <div class="panel-header">
            Project Auto Approval
        </div>

        <mat-slide-toggle [checked]="autoApprove" [color]="'primary'" (change)="autoApproval($event)">
            <div class="panel-description">
                When an agent applies for this Project it will be automatically approved if this switch is turned on.
            </div>
        </mat-slide-toggle>

    </div>
</div> -->
